import authRoles from 'app/auth/authRoles';
import { FuseLoadable } from '@fuse';

export const AutoMatching = {
    auth: authRoles.processor,
    routes: [
        {
            path: '/auto-matching',
            component: FuseLoadable({ loader: () => import('./AutoMatching') }),
        },
    ],
};

export default [AutoMatching];
